import React, { useState, useEffect } from 'react'
import { Select, Tag, message } from 'antd'

const { Option } = Select

const getTagColor = (tag) => {
  if (tag === '*RxRenewal_to_RxChange') return 'red'
  
  if (tag.includes('!')) return 'red'
  
  if (tag[0] === '*') return 'green'
  
  return 'grey'
}

const tagRender = ({ label, onClose }) => {
  const onPreventMouseDown = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  const isImmutable = label[0] === '*'
  
  return (
    <Tag
      color={getTagColor(label)}
      onMouseDown={onPreventMouseDown}
      closable={!isImmutable}
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {isImmutable ? label.substring(1) : label}
    </Tag>
  )
}

export const Tags = ({ 
  currentTags = [], 
  caseId, 
  onTagsChange,
  readOnlyMode = false,
  availableTags = []
}) => {
  const [tags, setTags] = useState(currentTags)

  useEffect(() => {
    setTags(currentTags || [])
  }, [currentTags])

  const handleTagChange = (newTagList) => {
    if (readOnlyMode) return

    try {
      const immutableTags = tags.filter(tag => tag[0] === '*')
      const addedTags = newTagList.filter(tag => !tags.includes(tag) && tag[0] !== '*')
      const removedTags = tags.filter(tag => !newTagList.includes(tag) && tag[0] !== '*')

      const updatedTags = Array.from(new Set([...newTagList, ...immutableTags]))
      setTags(updatedTags)

      if (onTagsChange) {
        onTagsChange({
          added: addedTags,
          removed: removedTags,
          allTags: updatedTags
        })
      }
    } catch (error) {
      console.error('Error updating tags:', error)
      message.error('Error updating tags')
    }
  }

  if (readOnlyMode) {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
        {tags.map(tag => (
          <Tag
            key={tag}
            color={getTagColor(tag)}
            style={{ marginRight: 3 }}
          >
            {tag[0] === '*' ? tag.substring(1) : tag}
          </Tag>
        ))}
        {tags.length === 0 && (
          <span style={{ color: '#999', fontSize: '12px' }}>No tags</span>
        )}
      </div>
    )
  }

  return (
    <Select
      id="case-tags-select"
      mode="tags"
      style={{ width: '100%' }}
      placeholder="Add a tag..."
      onChange={handleTagChange}
      value={tags}
      tagRender={tagRender}
      notFoundContent="No tags available"
    >
      {availableTags
        .filter(tag => tag[0] !== '*')
        .map(tag => (
          <Option key={tag} value={tag}>
            {tag}
          </Option>
        ))}
    </Select>
  )
}
